import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsSoftwareNextGenFeaturesRoute: InvariantJiraRoute = {
	name: 'project-settings-software-next-gen-features',
	path: '/jira/software/projects/:projectKey/settings/features',
	exact: true,
};
